import * as React from "react";
// UI Framework
import { Layout } from "antd";
// Styles
import styles from "./index.module.scss";

const Footer: React.FC = () => {
	const { Footer } = Layout;

	return <Footer className={styles["footer"]}>تمامی حقوق مادی و معنوی برای صاحب اثر محفوظ می باشد .</Footer>;
};

export default Footer;
